import IntlTelInput from 'intl-tel-input';

class CustomerDetail {
  constructor() {
    this._setup();
  }

  _setup() {
    const telInput = document.querySelector('#booking_phone_number');
    const iti = IntlTelInput(telInput, {
      initialCountry: 'th'
    });

    const numberType = iti.selectedCountryData.dialCode;
    telInput.value = telInput.value.replace(`+${numberType}`, '');

    const submit = document.querySelector('#formBookingSession__submit');
    submit.addEventListener('click', this.clickHandler);
  }

  clickHandler(event) {
    const telInput = document.querySelector('#booking_phone_number');
    const countryCodeInput = document.querySelector('#booking_country_code');
    const iti = window.intlTelInputGlobals.getInstance(telInput);

    const numberType = iti.selectedCountryData.dialCode;

    countryCodeInput.value = `+${numberType}`;
  }
}

if (document.querySelector('#booking_phone_number')) {
  new CustomerDetail();
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/CustomerDetail.js